import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { commonService } from '../../services/commonService';

export const useGetCountries = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.common.countries],
    queryFn: () =>
      commonService.countries().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
